import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const FormPage = () => {
  const { realtorId } = useParams();

  useEffect(() => {
    const ref = realtorId || '';
    const url = `https://ieum-landing.web.app/apply${ref ? `?ref=${ref}` : ''}`;
    window.location.replace(url);
  }, [realtorId]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', color: '#6B7280', fontSize: 14 }}>
      신청 페이지로 이동 중...
    </div>
  );
};

export default FormPage;
